/*
 * Initialisation code for the Data Table component
 */
"use strict";

( function( $ ) {
    if(!hamburger)
    {
        return;
    }
    // Execute code on document ready.
    $( document ).ready( function() {

        // Find the data tables and initialise them.
        $( ".data-table-component" ).each( function() {
            var table = $( this ).DataTable( {
                //responsive
                responsive: {
                    breakpoints: [
                        { name: 'desktop',  width: Infinity },
                        { name: 'tablet-l', width: 1200 },
                        { name: 'tablet-p', width: 992 },
                        { name: 'mobile-l', width: 576 },
                        { name: 'mobile-p', width: 320 }
                    ]
                },
               // position search bar and length.
                "dom": '<"pull-left top"f><"pull-right top"l>rt<"bottom"ip><"clear">',
                // Use the top header row for ordering.
                orderCellsTop: true,
                // Search icon and pagination.
                pagingType: 'input',
                language: {
                    search: "<i class='material-icons'>search</i>",
                    oPaginate: {
                        sNext: '<i class="material-icons">navigate_next</i>',
                        sPrevious: '<i class="material-icons">navigate_before</i>',
                        sFirst: '',
                        sLast: ''
                    }
                },
                // Adjust column specific settings.
                columnDefs: [
                    // Enable options for all columns.
                    {
                        targets: "_all", // Apply options to all columns.
                        type: "natural-nohtml", // Natural sorting without html.
                        render: {
                            "filter": function( data ) {
                                // Strip HTML tags from column items for searching / filtering only.
                                return data.replace(/(<([^>]+)>)/ig,"").trim();
                            }
                        }
                    }
                ],
                // Enable keyword highlighting.
                mark: true
            } );

            // Check to see if filtering is enabled.
            if ( $( this ).data( "enableFiltering" ) !== undefined ) {

                // Get a list of columns to disable if required.
                var noFilterList = $( this ).data( "disableFilterList" );
                if (noFilterList === undefined ) {
                    noFilterList = [];
                } else {
                    noFilterList = noFilterList.split( "," );
                }

                enableFiltering( table, noFilterList );

                table.on( "draw", function () {
                    enableFiltering( table, noFilterList );
                } );
            }

            // Check to see if initial column sorting has been specified.
            if ( $( this ).data("initSortColumn") !== undefined ) {
                // Get the name of the specified column.
                var initSortColumnName = $( this ).data( "initSortColumn" );
                initSortColumnName = initSortColumnName.trim().toLowerCase();

                var initSortColumnDir = $( this ).data( "initSortColumnDir" );

                if ( initSortColumnDir === undefined ) {
                    initSortColumnDir = "asc";
                } else {
                    initSortColumnDir = initSortColumnDir.trim().toLowerCase();
                }

                sortTable( table, initSortColumnName, initSortColumnDir );
            }
        } )
    } );

    // Add filtering capability to the table.
    // Based on example: http://live.datatables.net/gejojiqu/1/edit
    function enableFiltering( table, noFilterList ) {

        table.columns().every( function() {
            var column = table.column( this, { search: "applied" } );

            // Check to ensure column isn't in no filter list.
            if( noFilterList.includes( $(column.header()).text().trim().toLowerCase() ) === false ) {

                var select = $( '<select><option value=""></option></select>' )
                    .appendTo( $( table.table().header() ).find( "tr:eq(1) th" ).eq(column.index()).empty())
                    .on( "change", function() {
                        var val = $.fn.dataTable.util.escapeRegex( $( this ).val() );

                        column.search( val ? "^" + val + "$" : "", true, false )
                            .draw();
                    } );

                // Populate the dropdowns with a unique list of items from the column.
                // Use the data from the 'search' cache which is populated with the data for the 'filter' render.
                // AKA The trimmed cell value with HTML tags stripped.
                column.cache( "search" ).unique().sort().each( function( item ) {
                    select.append( '<option value="' + item + '">' + item + '</option>' );
                } );

                // The rebuild will clear the exisiting select, so it needs to be repopulated.
                var currSearch = column.search();
                if ( currSearch ) {
                    select.val( currSearch.substring(1, currSearch.length - 1 ) );
                }
            }
        } );
    }

    // Sort the table by a column specified by name.
    function sortTable( table, columnName, direction ) {
        // Get the list of columns and find the one that has been specified.
        table.columns().every( function() {
            // Match the column names.
            if ( columnName === $(this.header()).text().trim().toLowerCase() ) {
                // Set the sort order and redraw the table.
                this.order( direction );
                table.draw();
            }
        } );
    }

} )( jQuery );
